export default __webpack_public_path__ + "static/media/Ballroll_00115.70233b39.png";